import clsx from 'clsx';
import { forwardRef } from 'react';

import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { textStyle as textStyleCSS } from '../../../styles/textStyle.sty.js';
import { footerSlotCss } from '../EmptyState.sty.js';
import { footerCSS } from './Footer.sty.js';

//#region Typings
/**
 * @public
 */
export interface EmptyStateFooterProps
  extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * The footer slot for the EmptyState component.

* @public
*/
export const Footer = /* @__PURE__ */ forwardRef<
  HTMLElement,
  EmptyStateFooterProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  return (
    <footer
      ref={forwardedRef}
      className={clsx([
        footerCSS,
        footerSlotCss,
        textStyleCSS({ textStyle: 'base' }),
        consumerClassName,
      ])}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </footer>
  );
});

(Footer as typeof Footer & { displayName: string }).displayName =
  'EmptyState.Footer';
